<label
  #label
  class="radio-item"
  [class.radio-item--grouped]="grouped"
  [class.radio-item--disabled]="disabled"
  [tabindex]="disabled ? '-1' : '0'"
  (keydown.enter)="doChange($event, label)"
  (keydown.space)="doChange($event, label)"
>
  <input
    class="radio-item__native-radio"
    type="radio"
    tabindex="-1"
    [value]="value"
    [name]="name"
    [(ngModel)]="model"
    (ngModelChange)="onChange($event)"
    [disabled]="disabled"
  />

  <span class="radio-item__radio"></span>

  <span [class.content]="!grouped" [class.radio-item__radio--grouped]="grouped">
    <ng-content></ng-content>
  </span>
</label>
